import { Avatar, Dropdown, Space, Typography } from 'antd';
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../modules/auth/auth.store';
import { useAuthActions } from '../../modules/auth/useAuth';
import { LogoMark } from '../../pages/login/LoginBrandAssets';
import styles from './TopNav.module.css';

const { Text } = Typography;

const ROLE_LABEL = {
  admin: '管理员',
  doctor: '医生',
  technician: '技师',
  viewer: '只读',
} as const;

export function TopNav() {
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user);
  const { logout } = useAuthActions();

  return (
    <header className={styles.header}>
      <div className={styles.headerInner}>
        <Link to="/cases" className={styles.brandLink}>
          <LogoMark className={styles.logoMark} />
          <span className={styles.brandText}>Ortho Blader</span>
        </Link>
        <Dropdown
          trigger={['click']}
          menu={{
            items: [
              {
                key: 'logout',
                icon: <LogoutOutlined />,
                label: '退出登录',
                onClick: async () => {
                  await logout();
                  navigate('/login', { replace: true });
                },
              },
            ],
          }}
        >
          <Space className={styles.userTrigger ?? ''}>
            <Avatar size="small" icon={<UserOutlined />} className={styles.userAvatar ?? ''} />
            <Text className={styles.userName ?? ''}>
              {user?.name ?? '未登录'}
              {user ? `（${ROLE_LABEL[user.role]}）` : ''}
            </Text>
          </Space>
        </Dropdown>
      </div>
    </header>
  );
}
